// SUMMARY: Launch-sale and yearly-billing discount configuration used by the pricing display

/** Launch promo: percent off all paid tiers for the first months of a subscription. Set active: false to end the sale. */
export const LAUNCH_SALE = {
	active: true,
	discountPercent: 20,
	months: 3,
}

/** Standing discount for yearly billing — the launch promo stacks on top of this */
export const YEARLY_DISCOUNT_PERCENT = 15

/**
 * Apply a percentage discount to a price in euro-cents
 *
 * @example
 * applyDiscount(2000, 20) → 1600
 * applyDiscount(999, 15) → 849
 */
export function applyDiscount(priceCents: number, percent: number): number {
	return Math.round(priceCents * (1 - percent / 100))
}
